import { useState } from 'react';
import { api, ApiError, type Expedition, type Me } from '../api.js';
import { Loading, Page, useApi } from '../components.js';
import { href } from '../router.js';

export function Expeditions({ me }: { me: Me }) {
  const { data, error, refetch } = useApi<{ expeditions: Expedition[] }>('/api/expeditions');
  const [form, setForm] = useState({ title: '', startDate: '', endDate: '' });
  const [msg, setMsg] = useState<string | null>(null);
  return (
    <Page title="Expeditions">
      <p className="muted">Signed in as {me.name} · <a href={href.settings()}>Settings</a></p>
      {!data ? <Loading error={error} /> : (
        <ul className="list">
          {data.expeditions.map((e) => <li key={e.id}><a href={href.expedition(e.id)}>{e.title}</a> <span className="muted">{e.startDate} → {e.endDate}</span></li>)}
          {!data.expeditions.length && <li className="muted">No expeditions yet.</li>}
        </ul>
      )}
      <details>
        <summary>New expedition</summary>
        <form onSubmit={async (e) => {
          e.preventDefault();
          try { await api('POST', '/api/expeditions', form); setForm({ title: '', startDate: '', endDate: '' }); setMsg(null); refetch(); }
          catch (err) { setMsg((err as ApiError).message); }
        }}>
          <label>Title<input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required /></label>
          <label>First day<input type="date" value={form.startDate} onChange={(e) => setForm({ ...form, startDate: e.target.value })} required /></label>
          <label>Last day<input type="date" value={form.endDate} onChange={(e) => setForm({ ...form, endDate: e.target.value })} required /></label>
          {msg && <p className="error" role="alert">{msg}</p>}
          <button type="submit">Create</button>
        </form>
      </details>
    </Page>
  );
}
